'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { initDeepLinking } from '@/lib/utils/deep-linking'

/**
 * Opens the links that launch or reach the native app (Universal Links, App
 * Links and `alumnia://`) with the Next router (ALU-221). Mounted once, by
 * `NativeAppShell` at the root; the native listener itself is registered a
 * single time (see `initDeepLinking`), so a remount only re-points it at the
 * current router. No-op on web.
 */
export function useNativeDeepLinks() {
  const router = useRouter()

  useEffect(() => {
    let cancelled = false
    let cleanup: (() => void) | undefined

    void initDeepLinking(router).then((fn) => {
      if (cancelled) fn()
      else cleanup = fn
    })

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [router])
}
